export const convertToUri = (value) => value?.toLowerCase()?.replace(/[\s]/g,'-')